import { useAuth } from "@/lib/auth";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="px-6 lg:px-10 py-8 max-w-3xl mx-auto" data-testid="settings-page">
      <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-2">Settings</div>
      <h1 className="font-display text-3xl sm:text-4xl tracking-tighter font-medium">Workspace</h1>

      <div className="mt-8 bg-zinc-950 border border-white/10 rounded-xl p-6">
        <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">Account</div>
        <Row label="Name" value={user?.name} />
        <Row label="Email" value={user?.email} />
        <Row label="Business" value={user?.business_name} />
        <Row label="Plan" value={user?.plan} capitalize />
      </div>
    </div>
  );
}

function Row({ label, value, capitalize }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-white/5 last:border-0">
      <div className="text-sm text-zinc-500">{label}</div>
      <div className={`text-sm text-white ${capitalize ? "capitalize" : ""}`}>{value || "—"}</div>
    </div>
  );
}
